import { observable, action, runInAction } from 'mobx'
import contractSignApi from '@api/contractSign'
import { CONTRACT_SIGN_SUCCESS_A, HOME_PATH_A } from '@constant'

class Store {
  @observable
  merchantInfo = {
    posterId: ''
  }

  @observable
  contractInfo = {
    loading: false,
    merchant: {
      name: '',
      address: '',
      companyCode: ''
    },
    agreement: {
      title: '',
      content: ''
    },
    isSign: false
  }
  @observable agreeBtnLoading = false
  @observable requestDirty = false

  @action
  getContractInfo = async posterId => {
    this.contractInfo.loading = true
    this.posterId = posterId
    let { success, data } = await contractSignApi.getContent({
      agreement_id: posterId
    })
    if (success) {
      runInAction(() => {
        this.contractInfo.merchant = data.merchant
        this.contractInfo.agreement = data.agreement
        this.contractInfo.isSign = data.isSign
      })
    }
    runInAction(() => {
      this.requestDirty = true
      this.contractInfo.loading = false
    })
  }

  @action
  agreeContract = async () => {
    this.agreeBtnLoading = true
    let { success } = await contractSignApi.agreeContract({
      agreement_id: this.posterId
    })
    runInAction(() => {
      this.agreeBtnLoading = false
    })
    if (success) {
      window.location.href = CONTRACT_SIGN_SUCCESS_A
    }
  }

  disagree = () => {
    window.location.href = HOME_PATH_A
  }
}

export default Store
